import { EnvironmentType } from '@elementary/common-ui/types';

export const ELEMENTARY_IP = '3.126.156.226';

export const DBT_PACKAGE_DOCS_URL =
  'https://docs.elementary-data.com/cloud/onboarding/quickstart-dbt-package';

export const BIGQUERY_SERVICE_ACCOUNT_DOCS_URL =
  'https://docs.elementary-data.com/cloud/integrations/dwh/bigquery#service-account';

export const BIGQUERY_WIF_DOCS_URL =
  'https://docs.elementary-data.com/cloud/integrations/dwh/bigquery#workload-identity-federation';

export const ENVIRONMENT_TYPE_OPTIONS: {
  value: EnvironmentType;
  label: string;
}[] = [
  { value: 'dev', label: 'Dev' },
  { value: 'prod', label: 'Prod' },
  { value: 'test', label: 'Test' },
];

export const DREMIO_HOST_OPTIONS = [
  { value: 'api.dremio.cloud', label: 'US: api.dremio.cloud' },
  { value: 'api.eu.dremio.cloud', label: 'EU: api.eu.dremio.cloud' },
];

export const DEFAULT_SSH_PORT = 22;
export const MIN_PORT = 1;
export const MAX_PORT = 65535;
export const PORT_RANGE_ERROR = `Port must be an integer between ${MIN_PORT} and ${MAX_PORT}`;

export const ENVIRONMENT_CONTENT_STEP_TITLE = 'Environment content';

export const ENVIRONMENT_DRAWER_ACTIONS = {
  continue: 'Continue',
  save: 'Save',
  saving: 'Saving',
  saveAndSync: 'Save and sync',
  saveChanges: 'Save changes',
  configureAssetSources: 'Configure asset sources',
  setupWithAi: 'Set up with AI',
  editWithAi: 'Edit with AI',
};

export const CONNECTION_STEP_INDEX = 0;
export const CONTENT_STEP_INDEX = 1;

export const CONNECTION_STEP_TITLES = {
  create: 'New environment',
  edit: 'Edit environment',
};
